import React, { useContext, useState } from "react";
import "./styles.scss";
import {
    FaUserAlt,
} from "react-icons/fa";
import { SiAnalogue } from "react-icons/si";
import { IoMdBusiness } from "react-icons/io";
import {
    checkIfAdmin,
    checkIfColaborador,
    checkIfGestor,
} from "../../Functions";
import { ImBooks } from "react-icons/im";
import { AiFillBell, AiFillHome } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import MenuLink from "../MenuLink";
import MainContext from "../../Contexts/MainContext";
import { showToast } from "../../Functions";
import ModalCrud from "../ModalCrud";
import { GetAllNotifications, makeAllNotificationRead, makeOneNotificationRead } from "../../Services/ApiCalls";
import { getHour } from "../../Functions";
import Lottie from "react-lottie";

const LOADING = require("../../Assets/animations/loading.json");

interface SideBarProps {
    type: any | null;
}

const SideBar: React.FC<SideBarProps> = ({ type }) => {
    const isAdmin = checkIfAdmin(type.perfis);
    const isGestor = checkIfGestor(type.perfis);
    const isColaborador = checkIfColaborador(type.perfis);
    const { currentLoggedUserId, notificationCount, setNotificationCount, removeToken, sideNavOpen } = useContext(MainContext);
    
    const [showNotifications, setShowNotifications] = React.useState(false);

    const { dataAllNotifications, statusCodeAllNotifications } = GetAllNotifications(currentLoggedUserId);

    const rawUser = (type.username || '');
    const userPart = rawUser.split('@')[0].split('.')[0];
    const firstName = type.nome 
        ? type.nome.split(' ')[0] 
        : userPart.charAt(0).toUpperCase() + userPart.slice(1);

    return (
        <>
            <div className="sidebar__user-info">
                <img src={`https://ui-avatars.com/api/?name=${firstName}&background=0D8ABC&color=fff`} alt="Avatar" />
                <span>{firstName}</span>
            </div>

            <div className="side__block">
                <ul>
                    <li>
                        <MenuLink
                            icon={<AiFillHome color="#222" size={18} />}
                            text="Home"
                            from="dashboard"
                            link="/dashboard"
                        />
                    </li>
                </ul>
            </div>

            {(isGestor || isAdmin) && (
                <div className="side__block">
                    <span>Cadastro e consulta</span>
                    <ul>
                        <li>
                            <MenuLink
                                icon={<FaUserAlt color="#222" size={18} />}
                                text="Usuários"
                                from="dashboard"
                                link="/usuarios"
                            />
                        </li>
                        <li>
                            <MenuLink
                                icon={
                                    <IoMdBusiness color="#222" size={18} />
                                }
                                text="Config."
                                from="dashboard"
                                link="/estrutura-organizacional"
                            />
                        </li>
                    </ul>
                </div>
            )}
            {(isGestor || isAdmin) && (
                <div className="side__block">
                    <span>Relatórios</span>
                    <ul>
                        <li>
                            <MenuLink
                                icon={<ImBooks color="#222" size={18} />}
                                text="Relatórios"
                                from="dashboard"
                                link="/relatorios"
                            />
                        </li>
                        <li>
                            <MenuLink
                                icon={<SiAnalogue color="#222" size={18} />}
                                text="Logs"
                                from="dashboard"
                                link="/logs"
                            />
                        </li>
                    </ul>
                </div>
            )}

            <div className="sidebar__notifications">
                <div className="notif__bell" onClick={() => setShowNotifications(!showNotifications)}>
                    <AiFillBell size={24} color="#555" />
                    {dataAllNotifications.length > 0 && (
                        <div className="notif__badge">{dataAllNotifications.length}</div>
                    )}
                </div>

                {showNotifications && (
                    <div className="notifications__dropdown sidebar-notif">
                        <div className="dropdown__header">
                            <h3>Notificações</h3>
                            <p onClick={() => {
                                makeAllNotificationRead(currentLoggedUserId);
                                setNotificationCount(0);
                            }}>Marcar tudo como lido</p>
                        </div>
                        <div className="not__linha"></div>

                        {statusCodeAllNotifications === 200 ? (
                            <ul>
                                {dataAllNotifications.length === 0 ? (
                                    <li><p className="not__no">Nenhuma notificação</p></li>
                                ) : (
                                    dataAllNotifications.reverse().map((not: any) => (
                                        <li key={not._id}>
                                            <div className="not__area" onClick={() => {
                                                makeOneNotificationRead(not._id);
                                                setNotificationCount(notificationCount > 0 ? notificationCount - 1 : 0);
                                            }}>
                                                <div className="area__content">
                                                    <p>{not.content}</p>
                                                    <small>{getHour(new Date(not.date))}</small>
                                                </div>
                                            </div>
                                            <div className="not__linha"></div>
                                        </li>
                                    ))
                                )}
                            </ul>
                        ) : (
                            <div className="notif__loading">
                                <Lottie options={{ loop: true, animationData: LOADING }} height={60} width={60} />
                            </div>
                        )}
                    </div>
                )}
            </div>

        </>
    );
};
export default SideBar;
